import Swiper from './lib/swiper-bundle.min';

export default () => {
  const $swiperElement = document.getElementById('swiper-about');
  if (!$swiperElement) return;

  let $swiperParameter = {
    loop: false,
    slidesPerView: 1,
    spaceBetween: 32,
    speed: 1000,
    effect: 'fade',
    autoplay: { // 自動再生
      delay: 3000, // 1.5秒後に次のスライド
      disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
    },
    navigation: {
      nextEl: ".swiper-about-button-next",
      prevEl: ".swiper-about-button-prev",
    }
  };

  new Swiper($swiperElement, $swiperParameter);

}
